{
  "search": "Търсене",
  "searchWithin": "Търсене из"
}
